let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cuqmx")).then(() => parcelRequire('4yjfn'));